module.exports = __webpack_public_path__ + "static/media/travel-top@2x.ea55840c.png";